import { apiClient } from '@/lib/api-client';
import {
  toStoredFilesQuery,
  type FilesSummary,
  type Paginated,
  type StoredFile,
  type StoredFileDetail,
  type StoredFileFilters,
} from '../../domain/entities/stored-file.entity';

const BASE = '/admin/files';

export class FilesApiDatasource {
  async list(input: {
    page: number;
    perPage: number;
    filters: StoredFileFilters;
  }): Promise<Paginated<StoredFile>> {
    const { data } = await apiClient.get<Paginated<StoredFile>>(BASE, {
      params: {
        page: input.page,
        perPage: input.perPage,
        ...toStoredFilesQuery(input.filters),
      },
    });
    return data;
  }

  async summary(filters: StoredFileFilters): Promise<FilesSummary> {
    const { data } = await apiClient.get<FilesSummary>(`${BASE}/summary`, {
      params: toStoredFilesQuery(filters),
    });
    return data;
  }

  async get(fileId: string): Promise<StoredFileDetail> {
    const { data } = await apiClient.get<StoredFileDetail>(`${BASE}/${fileId}`);
    return data;
  }

  async viewUrl(fileId: string): Promise<string> {
    const { data } = await apiClient.get<{ url: string }>(
      `${BASE}/${fileId}/view-url`,
    );
    return data.url;
  }

  async forceDelete(fileId: string, reason: string): Promise<StoredFileDetail> {
    const { data } = await apiClient.delete<StoredFileDetail>(
      `${BASE}/${fileId}`,
      { data: { reason } },
    );
    return data;
  }

  async setLegalHold(
    fileId: string,
    input: { legalHold: boolean; reason?: string },
  ): Promise<StoredFileDetail> {
    const { data } = await apiClient.patch<StoredFileDetail>(
      `${BASE}/${fileId}/legal-hold`,
      input,
    );
    return data;
  }
}
